import { IState } from 'core/types';

export const getTables = ({ tables: { tablesData } }: IState) => tablesData;

export const getSelectedTableData = ({ tables: { selectedTableData } }: IState) =>
  selectedTableData;
